import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { injectable } from 'inversify';
import 'reflect-metadata';
import BaseNormalPass from "./BaseNormalPass";
/**
 * ClearPass
 */

var ClearPass = (_dec = injectable(), _dec(_class = /*#__PURE__*/function (_BaseNormalPass) {
  _inherits(ClearPass, _BaseNormalPass);

  var _super = _createSuper(ClearPass);

  function ClearPass() {
    _classCallCheck(this, ClearPass);

    return _super.apply(this, arguments);
  }

  _createClass(ClearPass, [{
    key: "getName",
    value: function getName() {
      return 'clear';
    }
  }, {
    key: "init",
    value: function init(layer, config) {
      _get(_getPrototypeOf(ClearPass.prototype), "init", this).call(this, layer, config);
    }
  }, {
    key: "render",
    value: function render() {
      this.rendererService.clear({
        color: [0, 0, 0, 0],
        depth: 1,
        framebuffer: null
      });
    }
  }]);

  return ClearPass;
}(BaseNormalPass)) || _class);
export { ClearPass as default };